'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('graph-view', {
            url: '/graph/:graphId?departmentId',
            templateUrl: 'dashboard-graph-view/dashboard-graph-view.html',
            controller: 'dashboardGraphViewCtrl as ctrl',
            abstract: false,
            resolve: {
                myGraph: ['Graph', '$stateParams','toast', 'Authentication', "$translate", function (Graph, $stateParams, toast, Authentication, $translate) {
                    // console.log('$stateParams.graphId', $stateParams.graphId)
                    return Graph.find({
                        filter: {
                            "where": {
                                "id": ($stateParams.graphId)
                            }
                        }
                    })
                    .$promise
                    .then(function (dest) {
                        let graph = (JSON.parse(JSON.stringify(dest)))[0];
                        return graph;                            
                    });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser','supervisor',"owner"]
            }
        });
};